import type { CSSProperties } from 'react';
import './profile-shared.css';

interface ProfileAvatarProps {
  name: string;
  initials?: string;
  color?: string;
  size?: number;
  square?: boolean;
  imageUrl?: string | null;
}

export function ProfileAvatar({
  name,
  initials,
  color = '#6B7A5A',
  size = 64,
  square = false,
  imageUrl,
}: ProfileAvatarProps) {
  const derived =
    initials ??
    name
      .split(/\s+/)
      .map((s) => s[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();

  if (imageUrl) {
    return (
      <span
        className={`tp-avatar${square ? ' tp-avatar--sq' : ''}`}
        style={
          {
            '--tp-avatar-size': `${size}px`,
            '--tp-avatar-radius': square ? '26%' : '50%',
            backgroundImage: `url(${imageUrl})`,
          } as CSSProperties
        }
        aria-hidden="true"
      />
    );
  }

  return (
    <span
      className={`tp-avatar${square ? ' tp-avatar--sq' : ''}`}
      style={
        {
          '--tp-avatar-size': `${size}px`,
          '--tp-avatar-radius': square ? '26%' : '50%',
          '--tp-avatar-bg': color,
        } as CSSProperties
      }
      aria-hidden="true"
    >
      {derived}
    </span>
  );
}
